import { BinaryTupleBase } from "abweb/dto/generated/ds/BinaryTupleBase";
export class BinaryTuple extends BinaryTupleBase {
  static createBinaryTuple(value, displayValue) {
    const retVal = new BinaryTuple();
    retVal.initBinaryTuple(displayValue, value);
    return retVal;
  }
  constructor() {
    super();
  }

  // among other things, this fixes the tooltip on a change decorator on an MhBinaryProperty
  toString() {
    return this.value ?? "";
  }
}
//# sourceMappingURL=BinaryTuple.js.map
